import React, { Fragment } from 'react';
import $ from 'jquery';
import { Redirect, Link } from 'react-router-dom';
import { withRouter } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import SessionService from '../../../services/session.service';
import { API_HOST } from '../../../constants/server.constant';
import './../topcreditcard.css';
import { axiosRequestWithAuth, axiosInstance } from './../../../constants/server.constant';
import { loginService } from '../../../services/login.service';
import CardSection from '../../account/CardSection';
import ResourceService from '../../../services/resource.service';
import CommonMessage from '../commonMessage';
import { CardElement, ElementsConsumer } from '@stripe/react-stripe-js';
import Validate from '../validate';
import { userService } from '../../../services/user.service';

class TopRightHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: localStorage.getItem("email"),
            userId: localStorage.getItem("userId"),
            roleId: localStorage.getItem("roleId"),
            email: this.props.email,
            datatip: true,
            showusername: true,
            isRedirectCCPage: false,
            regionSlider: false,
            regionCount: 0,
            regionList: [],
            notifyCount: true,
            isSuspended: localStorage.getItem("status") === 'S',
            suspendMsg: '',
            isSuspendAction: false,
            upgradeCCPopup: false,
            updateCCAction: false,
            showCardSection: false,
            showPersonDetails: false,
            phone: '',
            firstNameEmpty: false,
            firstnameregex: false,
            lastName: '',
            lastNameEmpty: false,
            lastnameregex: false,
            prevBillingAddress: '',
            prevZipCode: '',
            billingAddress: '',
            billingAddressEmpty: false,
            zipCode: '',
            zipCodeEmpty: false,
            lastdigits: '',
            month: '',
            year: '',
            last4digits: '',
            message: '',
            msgType: '',
            popupMsg: '',
            popupMsgType: '',
            showLoader: false,
            isUserSubscribed: undefined,
            showPopupMsg: false,
            isCreateExternalDisabled: !loginService.isInternalUser()
        };
        this.logOut = this.logOut.bind(this);
        this.dataTip = this.dataTip.bind(this);
        this.moveToCCPage = this.moveToCCPage.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.billingAddressInput = React.createRef();
        this.zipCodeInput = React.createRef();
        this.firstNameFocus = React.createRef();
        this.lastNameFocus = React.createRef();
    }

    checkForSubscription = () => {
        this.setState({ showLoader: true });
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    showLoader: false,
                    message: "Error while getting user subscription details"
                });
                return;
            } else if(resp.error) {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: false,
                });
            } else {
                this.setState({
                    showLoader: false,
                    isUserSubscribed: true,
                });
            }
        });
    };

    escfunction(event) {
        if(event.keyCode === 27) {
            $("body").removeClass("popup_no_scroll");
            this.setState({
                regionSlider: false,
                upgradeCCPopup: false,
            });
        }
    }

    openRegionStatus = () => {
        $(".main_slider").removeClass("active");
        $("body").addClass("popup_no_scroll");
        $(".cluster_slider").addClass("active");
        this.setState({
            notifyCount: false,
            isNotify: ""
        });
        localStorage.setItem("notifyCount", "hide");

    };

    updateDetails() {
        let emailId = localStorage.getItem("email");
        this.setState({ email: emailId });
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
        window.removeEventListener("storage", this.toggleUserActiveStatus, false);
        window.clearTimeout(sessionStorage.popupMsgTimeout);
        window.clearTimeout(sessionStorage.verifyOtpTimeout);
        clearInterval(sessionStorage.logInCheckInterval);
    }

    componentDidMount() {
        if(!(this.props.email != undefined)) {
            this.setState({
                email: localStorage.getItem("email")
            });
        }
        var notify = localStorage.getItem("notifyCount");
        if(notify !== null && notify !== undefined) {
            this.setState({
                isNotify: localStorage.getItem("notifyCount")
            });
        }
        else {
            localStorage.setItem("notifyCount", "show");
            this.setState({
                isNotify: "show"
            });
        }
        document.addEventListener("keyup", this.escfunction, false);
        $('.top_navbar .profile').click(function (e) {
            $('.top_navbar .profile_dropdown').addClass('active');
            $('.main_slider, .main_popup').removeClass('active');
        });

        window.addEventListener('storage', this.toggleUserActiveStatus, true);

        $(document).mouseup(function (e) {
            var container = $(".setting_dropdown, .backup_dropdown, .bn_dropdown_ul, .dropdown_component");

            // if the target of the click isn't the container nor a descendant of the container
            if(!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass('active');
            }
        });
        //this.timerApi = setInterval(()=> this.getMaintananceRegions(), 60000);
        this.checkForSubscription();
        this.getMaintananceRegions();
        this.isUserLoggedIn();
        userService.getUserDetails().then(res => {
            if(this.state.roleId == 1) return;
            if(res === false) {
                this.setState({
                    message: "Error while fetching details, try again!",
                    showLoader: true
                });
                return;
            }
            if(res.data.body.phone) {
                this.setState({
                    showPersonDetails: false,
                });
            } else {
                let fName = res.data.body.firstName;
                let lName = res.data.body.lastName;
                if(fName && lName) {
                    this.setState({
                        firstName: fName,
                        lastName: lName,
                        showPersonDetails: true,
                        countryCode: "USA +1"
                    });
                }
                else if(fName && !lName) {
                    this.setState({
                        firstName: fName,
                        showPersonDetails: true,
                        countryCode: "USA +1"
                    });
                }
                else if(!fName && lName) {
                    this.setState({
                        lastName: lName,
                        showPersonDetails: true,
                        countryCode: "USA +1"
                    });
                }
                else {
                    this.setState({
                        showPersonDetails: true,
                        countryCode: "USA +1"
                    });
                }

            }

        });
        if(this.state.roleId == 1) return;
        this.getCCDetails();
    }

    getSuspendMsg = () => {
        userService.getSuspendMsg(localStorage.getItem("userId")).then(data => {
            if(data) {
                this.setState({
                    suspendMsg: data.message
                });
            }
            this.setState({
                isSuspendAction: true
            });
        }).catch(err => {
            this.setState({
                isSuspendAction: true
            });
        });
    };

    toggleUserActiveStatus = (event) => {
        if(localStorage.getItem("status") !== 'S') {
            this.setState({
                isSuspended: false,
            });
        } else {
            this.setState({
                isSuspended: true
            });
            this.getSuspendMsg();
        }
    };

    getMaintananceRegions = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + "/regions/maintainance/" + userId, axiosRequestWithAuth)
            .then(resp => {
                if(resp?.data) {
                    let res = resp.data;
                    this.setState({
                        regionCount: res.length,
                        regionList: res
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
    };
    dataTip = (e) => {
        this.setState({
            datatip: !this.state.datatip
        });
    };

    logOut = () => {
        loginService.redirectToLogin();
    };

    moveToPage(name) {
        let hostUrl = 'https://' + window.location.host;
        /* if(name==='faq'){
             window.location.href = hostUrl + '/faq.htm'
         }*/
        let a = document.createElement('a');
        a.target = '_blank';
        a.href = hostUrl + '/faq.htm';
        a.click();
    }

    isUserLoggedIn() {
        sessionStorage.logInCheckInterval = setInterval(() => {
            //console.log("checking is logged in")
            if(!SessionService.getCookie("isLoggedIn")) {
                this.logOut();
            }
        }, 3000);
    }

    moveToCCPage() {
        this.setState({
            isRedirectCCPage: true
        });
    }

    upgradeCCPopupClick = () => {
        this.setState({
            upgradeCCPopup: true,
        });
    };

    getCCDetails() {
        ResourceService.getCCDetails().then(data => {
            //console.log(data)
            this.setState({
                showLoader: false
            });
            if(data && data !== "") {
                this.setCCDetails(data);
                // this.toggleStripeForm(true);
            } else {
                // this.toggleStripeForm(false);
            }
        }).catch(err => {
            console.log(err);
            this.setState({
                message: "Error while fetching details, try again!",
                showLoader: false,
                msgType: 'error'
            });
            return;
        });
    }

    setCCDetails(data) {
        this.setState({
            lastdigits: data.last4digits,
            billingAddress: data.billingaddress,
            zipCode: data.zipcode,
            cardType: data.cardType,
            month: data.expiry.toString().substring(0, 2),
            year: data.expiry.toString().substring(4),
            prevBillingAddress: data.billingaddress,
            prevZipCode: data.zipcode,
        });

        // this.toggleStripeForm(data);
    }

    handleFormChanges = (event) => {

        this.setState({
            billingAddressEmpty: false,
            zipCodeEmpty: false,
            firstNameEmpty: false,
            firstnameregex: false,
            lastNameEmpty: false,
            lastnameregex: false,
            phoneNumberEmpty: false,
            phoneregex: false,
            countrycodeempty: false,
            otpempty: false
        });

        let name = event.target.name;
        let val = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if(name == "billingAddress") {
            this.setState({
                billingAddressEmpty: false,
            });
            this.setState({ billingAddress: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        billingAddressEmpty: false,
                    });
                }
                else if(val.length <= 0) {
                    this.setState({
                        billingAddressEmpty: true,
                    });
                }
            });
        }
        if(name == "zipCode") {
            this.setState({ zipCode: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        zipCodeEmpty: false,
                    });
                }
                else if(val.length <= 0) {
                    this.setState({
                        zipCodeEmpty: true,
                    });
                }
            });
        }

        if(name === "firstName") {
            this.setState({ firstName: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        firstNameEmpty: false,
                        firstnameregex: false
                    });
                }
            });
        }

        if(name === "lastName") {
            this.setState({ lastName: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        lastNameEmpty: false,
                        lastnameregex: false
                    });
                }
            });
        }

        if(name === "countryCode") {
            this.setState({ countryCode: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        countrycodeempty: false
                    });
                }
            });
        }

        if(name === "phone") {
            this.setState({ phone: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        phoneNumberEmpty: false,
                        phoneregex: false
                    });
                    if(val.length >= 7) {
                        $('#min_sev').addClass("success");
                    } else {
                        $('#min_sev').removeClass("success");
                    }

                    if(val.length > 0 && val.length <= 20) {
                        $('#max_twe').addClass("success");
                    } else {
                        $('#max_twe').removeClass("success");
                    }

                    const phoneNumRegex = new RegExp("^[xX0-9-+()]+$");
                    if(phoneNumRegex.test(val)) {
                        $('#no_spe').addClass("success");
                    } else {
                        $('#no_spe').removeClass("success");
                    }

                }
                else {
                    $('#min_sev').removeClass("success");
                    $('#max_twe').removeClass("success");
                    $('#no_spe').removeClass("success");
                }
            });
        }

        if(name === "otp") {
            this.setState({ otp: val }, function () {
                if(val.length > 0) {
                    this.setState({
                        otpempty: false
                    });
                }
            });
        }
    };

    getFocus = (event, param) => {
        if(param === "zipcode") {
            if(this.state.billingAddress.length <= 0) {
                this.setState({
                    billingAddressEmpty: true
                });
            }
            else {
                this.setState({
                    billingAddressEmpty: false
                });
            }
        }
    };

    cancelCCUpdate = () => {
        this.closePopupMsgClick();
        this.setState({
            billingAddress: this.state.prevBillingAddress,
            zipCode: this.state.prevZipCode,
            updateCCAction: false,
            showCardSection: false,
        });
    };

    showStripeForm = () => {
        this.closePopupMsgClick();
        this.setState({
            billingAddress: '',
            zipCode: '',
            updateCCAction: true,
            showCardSection: true,
        });
    };

    validate() {

        this.setState({
            billingAddress: this.state.billingAddress.trim(),
            zipCode: this.state.zipCode.trim(),
            firstName: this.state.firstName.trim(),
            lastName: this.state.lastName.trim(),
            phone: this.state.phone.trim(),
        });

        this.setState({
            billingAddressEmpty: false,
            zipCodeEmpty: false,
            firstNameEmpty: false,
            firstnameregex: false,
            lastNameEmpty: false,
            lastnameregex: false,
            phoneNumberEmpty: false,
            phoneregex: false,
            countrycodeempty: false
        });

        if(this.state.billingAddress.length <= 0) {
            this.setState({
                billingAddressEmpty: true,
            });
            this.billingAddressInput.current.focus();
            return false;
        } else if(this.state.zipCode.length <= 0) {
            this.setState({
                zipCodeEmpty: true,
            });
            this.zipCodeInput.current.focus();
            return false;
        }

        if(this.state.showPersonDetails) {
            if(this.state.firstName.length <= 0) {
                this.setState({
                    firstNameEmpty: true
                });
                this.firstNameFocus.current.focus();
                return false;
            }

            if(!(Validate("firstName", this.state.firstName))) {

                this.setState({
                    firstnameregex: true
                });
                this.firstNameFocus.current.focus();
                return false;
            }

            if(this.state.lastName.length <= 0) {
                this.setState({
                    lastNameEmpty: true
                });
                this.lastNameFocus.current.focus();
                return false;
            }

            if(!(Validate("lastName", this.state.lastName))) {
                this.setState({
                    lastnameregex: true
                });
                this.lastNameFocus.current.focus();
                return false;
            }

            if(this.state.countryCode.length <= 0) {
                this.setState({
                    countrycodeempty: true
                });
                return false;
            }

            if(this.state.phone.length <= 0) {
                this.setState({
                    phoneNumberEmpty: true
                });
                this.phoneNUmberFocus.current.focus();
                return false;
            }

            if(!(Validate("phoneNumber", this.state.phone))) {
                this.setState({
                    phoneregex: true
                });
                this.phoneNUmberFocus.current.focus();
                return false;
            }

        }

        return true;
    }

    updateCCDetails = (event) => {
        event.preventDefault();
        if(this.validate()) {
            if(!this.state.showPersonDetails) {
                if(this.state.billingAddress == this.state.prevBillingAddress && this.state.zipCode == this.state.prevZipCode) {
                    this.setPopupMsg("Make changes to save card details.", 'error');
                    return;
                }
            }
            this.setState({
                showLoader: true
            });
            var ccDetails = {
                "ccdetails": {
                    "userid": localStorage.getItem('userId'),
                    "billingaddress": this.state.billingAddress,
                    "zipcode": this.state.zipCode,
                }
            };

            ResourceService.updateCCDetails(JSON.stringify(ccDetails)).then(data => {
                //console.log(data);
                if(data) {
                    this.setState({
                        showLoader: false,
                        prevBillingAddress: data.billingaddress,
                        prevZipCode: data.zipcode,
                        updateCCAction: false,
                        showCardSection: false,
                    });
                    this.setPopupMsg("Credit card details updated successfully.", 'success');
                } else {
                    this.setState({
                        showLoader: false,
                    });
                    this.setPopupMsg('Error occurred while updating details', 'error');
                }
            }).catch(err => {
                console.log(err);
                this.setState({
                    showLoader: false,
                });
                this.setPopupMsg('Error occurred while updating details', 'error');
            });

        }

    };

    handleSubmit = async event => {
        event.preventDefault();
        const { stripe, elements } = this.props;
        if(!stripe || !elements) {
            return;
        }
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card, { address_line1: this.state.billingAddress, address_zip: this.state.zipCode });
        if(result.error) {
            console.log(result.error.message);
            this.setState({
                showLoader: false,
            });
            this.setPopupMsg('An error occurred while updating the card details. You can try again after sometime or try adding another card.', 'error');
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return;
        } else {
            //console.log(result.token);
            this.setState({
                stripeToken: result.token
            });
            if(this.validate()) {
                if(!this.state.showPersonDetails) {
                    var ccDetails = {
                        "ccdetails": {
                            "token": JSON.stringify(this.state.stripeToken),
                            "userid": localStorage.getItem('userId'),
                            "billingaddress": this.state.billingAddress,
                            "zipcode": this.state.zipCode,
                            "isDetailsUpdated": "YES"
                        }
                    };
                    this.addCCDetails(ccDetails);
                } else {
                    this.setState({
                        smsType: "send"
                    }, () => this.recaptchaRef.current.execute());

                }
            }
        }

    };

    addCCDetails(ccDetails) {

        this.setState({
            showLoader: true,
            showVerifyLoader: true
        });

        ResourceService.addCCDetails(JSON.stringify(ccDetails)).then(data => {
            this.setState({
                showVerifyLoader: false
            });
            //console.log(data);
            if(data == "CARD_ERROR") {
                this.setState({
                    showLoader: false,
                });
                this.setPopupMsg('An error occurred while updating the card details. You can try again after sometime or try adding another card.', 'error');
                this.closePhoneVerifyPopup();
                return;
            } else if(data == "INVALID_OTP") {
                $('#verify_otp_msg').show();
                sessionStorage.verifyOtpTimeout = setTimeout(() => {
                    $('#verify_otp_msg').hide();
                }, 5000);
                this.setState({
                    otp: ""
                }, () => {
                    this.toggleVerifyButton();
                });
                this.otpInput.current.focus();
                return;
            } else if(data == "DETAILS_ERROR") {
                this.setState({
                    showLoader: false,
                });
                this.setPopupMsg('An error occurred while updating the card details.', 'error');
                this.closePhoneVerifyPopup();
                return;
            }

            localStorage.setItem("firstName", this.state.firstName);
            localStorage.setItem("lastName", this.state.lastName);
            localStorage.setItem("countryCode", this.state.countryCode);
            localStorage.setItem("phone", this.state.phone);
            let msg = "";
            if(this.state.showPersonDetails) {
                msg = "Account details have been updated";
            }
            else {
                msg = "Credit card details updated successfully.";
            }
            this.setState({
                showLoader: false,
                showPersonDetails: false,
                updateCCAction: false,
                showCardSection: false,
            });
            this.setPopupMsg(msg, 'success');
            this.setCCDetails(data);
        }).catch(err => {
            console.log(err);
            if(this.state.isPhoneVerifyPopup) {
                $('#verify_otp_msg').show();
                sessionStorage.verifyOtpTimeout = setTimeout(() => {
                    $('#verify_otp_msg').hide();
                }, 5000);
            } else {
                this.setState({
                    showLoader: false,
                });
                this.setPopupMsg('An error occurred while updating the card details. You can try again after sometime or try adding another card.', 'error');
            }
            return;
        });
    }

    saveChangesClick = (event) => {
        this.state.updateCCAction ? this.handleSubmit(event) : this.updateCCDetails(event);
    };

    closePopupBtnClick = (event) => {
        event.preventDefault();
        this.cancelCCUpdate();
        this.setState({
            upgradeCCPopup: false,
        });
    };

    closeSlider = () => {
        this.setState({ regionSlider: false });
        $("body").removeClass("popup_no_scroll");
    };

    closePopupMsgClick = () => {
        this.setState({
            showPopupMsg: false,
        });
        clearTimeout(sessionStorage.popupMsgTimeout);
    };

    setPopupMsg = (msg, msgType) => {
        if(msg != '') {
            this.setState({
                popupMsg: msg,
                popupMsgType: msgType,
                showPopupMsg: true,
            });
            sessionStorage.popupMsgTimeout = setTimeout(() => {
                this.setState({
                    showPopupMsg: false,
                });
            }, 5000);
        }
    };

    render() {
        var cls1 = {
            fill: "#6c6c70"
        };
        var cls2 = {
            fill: "none"
        };
        if(this.state.isRedirectCCPage && window.location.pathname !== "/app/billing/creditcard") {
            this.setState({
                isRedirectCCPage: false,
            });
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        return (
            <Fragment>
                <div className="tn_right">
                    <div className="cc_upgrade_wrap right_bor" style={ { display: this.state.roleId === '2' && this.state.isUserSubscribed && !this.state.isSuspended && !String(window.location.pathname).startsWith("/app/billing/creditcard") && !this.state.isCreateExternalDisabled ? "" : "none", cursor: "pointer" } }>
                        <a className="cc_btn" onClick={ this.upgradeCCPopupClick }>
                            <svg x="0px" y="0px" viewBox="0 0 16.9 13.5" enableBackground="new 0 0 16.9 13.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" className="cc1" d="M15.2,12.8H1.7c-0.7,0-1.3-0.6-1.3-1.3V6.8v-1v-1v-1V2  c0-0.7,0.6-1.3,1.3-1.3h13.4c0.7,0,1.3,0.6,1.3,1.3v1.7v1v6.7C16.5,12.2,15.9,12.8,15.2,12.8z M15.4,1.8h-14v2h14V1.8z M15.4,4.8  h-14v1h5v1h-5v5h14V4.8z M9.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S8.9,7.8,9.4,7.8z M12.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1  s-1-0.4-1-1S11.9,7.8,12.4,7.8z"></path></svg>
                            <span>Change Credit Card</span>
                        </a>
                    </div>
                    <div className="cc_update_wrap" onClick={ () => {
                        this.moveToCCPage();
                        document.getElementById("add_credit_btn").blur();
                    } } style={ { display: this.state.isUserSubscribed === false && !String(window.location.pathname).startsWith("/app/billing") && !this.state.isCreateExternalDisabled ? "" : "none" } }> <a className="free_trial" id=""> <span className="free_trial_msg">Link a credit card to your account for deploying high-speed NVMe SSD servers in seconds</span>
                            <button id="add_credit_btn" className="update_credit_btn" >Add Credit Card</button>
                        </a>
                    </div>
                    <div className="cc_update_wrap suspend_wrap" onClick={ () => {
                        this.moveToCCPage();
                        document.getElementById("update_credit_btn").blur();
                    } } style={ { display: this.state.isSuspended && !String(window.location.pathname).startsWith("/app/billing/creditcard") && this.state.isSuspendAction && !this.state.isCreateExternalDisabled ? "" : "none", pointerEvents: localStorage.getItem("roleId") === "1" ? "none" : "auto" } }>
                        <a className="suspend_info" id="">
                            { this.state.suspendMsg === '' ?
                                localStorage.getItem("roleId") === '1' ?
                                    <span className="suspend_info_msg">
                                        <em>Your account has been suspended.</em> Contact your admin for further details.
                                    </span> :
                                    <span className="suspend_info_msg">
                                        <em>Your account has been suspended due to non payment.</em>  Please update your payment information and clear any pending charges to reactivate your account.
                                    </span>
                                :
                                <span className="suspend_info_msg">
                                    { this.state.suspendMsg }
                                </span>
                            }
                            <button id="update_credit_btn" className="update_credit_btn" style={ { display: localStorage.getItem("roleId") === '1' ? "none" : "" } } >Update Card Info</button>
                        </a>
                    </div>

                    <div className="tn_btn_grp">

                        <div className="help_icon" onClick={ () => this.moveToPage('faq') }>
                            <div className="icon" data-tip data-for="Help">
                                <svg x="0px" y="0px" viewBox="0 0 17.5 17.8" enableBackground="new 0 0 17.5 17.8" xmlSpace="preserve">
                                    <g>
                                        <path fillRule="evenodd" clipRule="evenodd" fill="#9198A1" d="M8.8,17.5c-4.6,0-8.4-3.7-8.4-8.4s3.7-8.4,8.4-8.4   s8.4,3.7,8.4,8.4S13.4,17.5,8.8,17.5z M8.8,2.1c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S12.7,2.1,8.8,2.1z"></path>
                                        <g>
                                            <path fill="#9198A1" d="M9.7,11.1H8.1c0-0.2,0-0.4,0-0.4c0-0.5,0.1-1,0.2-1.3c0.1-0.3,0.5-0.7,1-1.1c0.5-0.4,0.8-0.7,0.9-0.8    c0.1-0.2,0.2-0.4,0.2-0.7c0-0.4-0.1-0.6-0.4-0.9C9.8,5.6,9.5,5.5,9,5.5S8.2,5.6,7.9,5.9C7.6,6.1,7.4,6.5,7.3,7L5.7,6.9    c0.1-0.7,0.4-1.3,1-1.9S8,4.3,9,4.3s1.8,0.3,2.4,0.8s0.9,1.1,0.9,1.8c0,0.4-0.1,0.7-0.3,1.1c-0.2,0.4-0.7,0.8-1.4,1.4    C10.2,9.8,10,10,9.9,10.2C9.8,10.4,9.7,10.7,9.7,11.1z M8.1,13.5v-1.8h1.7v1.7L8.1,13.5L8.1,13.5z"></path>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <ReactTooltip id="Help" place="left" effect="solid">Help
                            </ReactTooltip>
                        </div>


                        { <div className="notification_icon openSlider" style={ { display: this.state.regionCount > 0 ? "" : "none" } } onClick={ () => { this.dataTip(); this.openRegionStatus(); } } >

                            <div className="icon" >
                                <svg x="0px" y="0px" width="25px" height="25px" viewBox="0 0 25 25" enableBackground="new 0 0 25 25" xmlSpace="preserve" data-tip data-for="notification">
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#9198A1" d="M22.5,17.6c0,1.9-1.6,3.5-3.5,3.5h-3.5c0,1.7-1.3,3-3,3s-3-1.3-3-3  H6c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5H5.5v-3c0-2.8,1.7-5.2,4.1-6.4C9.5,4.6,9.5,4.4,9.5,4.1c0-1.7,1.3-3,3-3s3,1.3,3,3  c0,0.2,0,0.5-0.1,0.6c2.4,1.1,4.1,3.5,4.1,6.4v3H19C20.9,14.1,22.5,15.7,22.5,17.6z M12.5,22.1c0.6,0,1-0.4,1-1s-0.4-1-1-1  s-1,0.4-1,1S12,22.1,12.5,22.1z M12.5,3.1c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S13.1,3.1,12.5,3.1z M19,16.1h-1.5v-2v-1v-2  c0-2.8-2.2-5-5-5s-5,2.2-5,5v2v1v2H6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h13c0.8,0,1.5-0.7,1.5-1.5S19.8,16.1,19,16.1z"></path>
                                </svg><ReactTooltip id="notification" place="left" effect="solid">
                                    Notification
                                </ReactTooltip>
                                <span className="notify_count" style={ { display: this.state.notifyCount && this.state.isNotify == "show" && this.state.regionCount > 0 ? "" : "none" } }>1</span>
                            </div>

                            <div className="dropdown_component notify_dropdown">
                                <span className="arrow_pointer"></span>
                                <ul>

                                    <li>
                                        <figure className="success">
                                            <svg x="0px" y="0px" width="11.4px" height="9.1px" viewBox="0 0 11.4 9.1" enableBackground="new 0 0 11.4 9.1" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#50BD83" d="M5.7,7.2L4.3,8.7L0.7,5l1.4-1.5l2.1,2.2l5-5.1l1.4,1.5L5.7,7.2  L5.7,7.2z"></path>
                                            </svg>
                                        </figure>
                                        <p>Added a new VM</p>
                                        <p className="desc">All the options have been enabled.</p>
                                    </li>
                                    <li>
                                        <figure className="success">
                                            <svg x="0px" y="0px" width="11.4px" height="9.1px" viewBox="0 0 11.4 9.1" enableBackground="new 0 0 11.4 9.1" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#50BD83" d="M5.7,7.2L4.3,8.7L0.7,5l1.4-1.5l2.1,2.2l5-5.1l1.4,1.5L5.7,7.2  L5.7,7.2z"></path>
                                            </svg>
                                        </figure>
                                        <p>Added a new VM</p>
                                        <p className="desc">All the options have been enabled.</p>
                                    </li>
                                    <li>
                                        <figure className="success">
                                            <svg x="0px" y="0px" width="11.4px" height="9.1px" viewBox="0 0 11.4 9.1" enableBackground="new 0 0 11.4 9.1" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#50BD83" d="M5.7,7.2L4.3,8.7L0.7,5l1.4-1.5l2.1,2.2l5-5.1l1.4,1.5L5.7,7.2  L5.7,7.2z"></path>
                                            </svg>
                                        </figure>
                                        <p>Added a new VM</p>
                                        <p className="desc">All the options have been enabled.</p>
                                    </li>
                                    <li>
                                        <figure className="success">
                                            <svg x="0px" y="0px" width="11.4px" height="9.1px" viewBox="0 0 11.4 9.1" enableBackground="new 0 0 11.4 9.1" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#50BD83" d="M5.7,7.2L4.3,8.7L0.7,5l1.4-1.5l2.1,2.2l5-5.1l1.4,1.5L5.7,7.2  L5.7,7.2z"></path>
                                            </svg>
                                        </figure>
                                        <p>Added a new VM</p>
                                        <p className="desc">All the options have been enabled.</p>
                                    </li>
                                </ul>

                            </div>

                        </div> }

                        <div className="qa_icon">
                            <div className="icon"></div>
                        </div>
                        <div className="profile"  >
                            <span className="icon_container" data-tip data-for="email" >
                                <div className="alpha_wrap" onClick={ () => { this.setState({ showusername: false }); } } onMouseLeave={ () => { this.setState({ showusername: true }); } }>
                                    <div className="alpha" >{ this.state.firstName ? this.state.firstName.charAt(0).toUpperCase() : 'G' }</div>
                                </div>{ this.state.showusername ? <ReactTooltip id="email" place="left" effect="solid">
                                    { this.props.email }
                                </ReactTooltip> : "" }
                            </span>
                            <ul className="dropdown_component profile_dropdown">
                                <span className="arrow_pointer"></span>
                                <li className="my_acc">
                                    <span className="svg_wrap">
                                        <svg viewBox="0 0 21.36 21.36" >
                                            {/* <defs>
                                        <style>
                                            {
                                                .my_acc .cls-1 {
                                                    fill: #6c6c70;
                                                }
                                                .my_acc .cls-2 {
                                                    fill: none;
                                                }
                                            }
                                        </style>
                                    </defs> */}
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M298,422.33a4,4,0,1,1,4-4A4,4,0,0,1,298,422.33Zm0-6.42a2.46,2.46,0,1,0,2.46,2.46A2.46,2.46,0,0,0,298,415.92Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "none" } }
                                                d="M298,422.33a5.74,5.74,0,0,0-5.7,5.22,9.13,9.13,0,0,0,11.41,0A5.74,5.74,0,0,0,298,422.33Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "none" } }
                                                d="M298,420.83a7.24,7.24,0,0,1,7,5.46,9.18,9.18,0,1,0-14,0A7.24,7.24,0,0,1,298,420.83Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M292.25,427.55a5.73,5.73,0,0,1,11.41,0,9.25,9.25,0,0,0,1.3-1.26,7.22,7.22,0,0,0-14,0A9.25,9.25,0,0,0,292.25,427.55Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M292.25,427.55c0,.17,0,.34,0,.51a5.7,5.7,0,0,0,.19,1.42,10.58,10.58,0,0,0,11.09,0,5.7,5.7,0,0,0,.19-1.42c0-.17,0-.34,0-.51a9.13,9.13,0,0,1-11.41,0Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M308.64,420.38a10.68,10.68,0,1,0-17.9,7.84c0-.05,0-.1,0-.16a7.2,7.2,0,0,1,.23-1.77,9.18,9.18,0,1,1,14,0,7.2,7.2,0,0,1,.23,1.77c0,.05,0,.1,0,.16A10.64,10.64,0,0,0,308.64,420.38Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M292.23,428.06c0-.17,0-.34,0-.51a9.25,9.25,0,0,1-1.3-1.26,7.2,7.2,0,0,0-.23,1.77c0,.05,0,.1,0,.16a10.72,10.72,0,0,0,1.68,1.27A5.7,5.7,0,0,1,292.23,428.06Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M305,426.3a9.25,9.25,0,0,1-1.3,1.26c0,.17,0,.34,0,.51a5.7,5.7,0,0,1-.19,1.42,10.72,10.72,0,0,0,1.68-1.27c0-.05,0-.1,0-.16A7.2,7.2,0,0,0,305,426.3Z"
                                                transform="translate(-287.28 -409.7)"></path>
                                        </svg>
                                    </span>
                                    { this.props.email }
                                    <input
                                        type="button"
                                        name=""
                                        value="My Account"
                                        className="common_cta_btn blue" onClick={ () => this.props.history.push('/account/profile') } /></li>
                                <Link to="/web-activity">
                                    <li className="act_logs">
                                        <span className="svg_wrap">
                                            <svg viewBox="0 0 17.58 15">
                                                {/* <defs>
                                        <style>
                                            {
                                                "\ .cls-1 {\ fill: #757577;\ fillRule: evenodd;\ }\ "
                                            }
</style>
                                    </defs> */}
                                                <path
                                                    style={ { fill: "#757577", fillRule: "evenodd" } }
                                                    d="M20.12,8.1,16,12.46,11.64,8.33,15,8.24A5.36,5.36,0,0,0,13.63,6.5a5.51,5.51,0,1,0,.6,7.77,6.5,6.5,0,0,0,.44-.63l1.65,1.1a7.32,7.32,0,0,1-.58.83A7.5,7.5,0,1,1,14.93,5a7.3,7.3,0,0,1,2.15,3.19Z"
                                                    transform="translate(-2.54 -3.18)"></path>
                                            </svg>
                                        </span>
                                        Activity Logs
                                    </li>
                                </Link>
                                <li className="logout" onClick={ this.logOut }>
                                    <span className="svg_wrap">
                                        <svg viewBox="0 0 17.53 20.17">
                                            {/* <defs>
                                        <style>
                                            {
                                                "\ .logout .cls-1,\ .logout .cls-2 {\ fill: #6c6c70;\ }\ .logout .cls-2 {\ fill - rule: evenodd;\ }\ "
                                            }
</style>
                                    </defs> */}
                                            <title>exit</title>
                                            <path
                                                style={ { fill: "#6c6c70" } }
                                                d="M302.28,430.33H291.72a2.73,2.73,0,0,1-2.72-2.72V412.89a2.73,2.73,0,0,1,2.72-2.72h10.55a2.73,2.73,0,0,1,2.72,2.72v2.28h-2v-2.28a.72.72,0,0,0-.72-.72H291.72a.72.72,0,0,0-.72.72v14.72a.72.72,0,0,0,.72.72h10.55a.72.72,0,0,0,.72-.72V425h2v2.61A2.73,2.73,0,0,1,302.28,430.33Z"
                                                transform="translate(-289 -410.17)"></path>
                                            <path
                                                style={ { fillRule: "evenodd" } }
                                                d="M293.21,421.51h9.67l-3.82,3.79h2.7l4.77-4.73-4.77-4.73h-2.7l3.82,3.79h-9.67Z"
                                                transform="translate(-289 -410.17)"></path>
                                        </svg>
                                    </span>
                                    Logout
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/** BEGIN Upgrade CC Popup */ }
                <div className={ this.state.upgradeCCPopup ? "main_popup updateCreditCard_popup active" : "main_popup updateCreditCard_popup" }>
                    <div className="full_page_loader" style={ { display: this.state.showLoader ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap">
                                <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" data-tip data-for="closePopup_cc" onClick={ this.closePopupBtnClick }></span>
                                <div className="popup_header">
                                    <div className="back_btn" style={ { display: this.state.updateCCAction ? "block" : "none" } } onClick={ this.cancelCCUpdate }><span className="bck_icon" data-tip data-for="back_btn_cc"><span className="svg_wrap">➔</span></span></div>
                                    <div className="sub_title">Change credit card details</div>
                                    <ReactTooltip id="back_btn_cc" effect="solid" place="top" multiline={ true }>
                                        Back
                                    </ReactTooltip>
                                    <ReactTooltip id="closePopup_cc" effect="solid" place="top" multiline={ true }>
                                        Close
                                    </ReactTooltip>
                                </div>

                                <form>
                                    <div className="popup_body">
                                        <div className={ this.state.popupMsgType === 'error' ? "popup_msg error" : "popup_msg" } style={ { display: this.state.showPopupMsg ? "" : "none" } }>
                                            <div className="message_content"><p>{ this.state.popupMsg }</p>
                                                <span className="close_icon" datatoggle="tooltip" data-tip data-for="closePopupError" dataoriginaltitle="Close" onClick={ this.closePopupMsgClick }></span>
                                                <ReactTooltip id="closePopupError" effect="solid" place="top" multiline={ true }>
                                                    Close
                                                </ReactTooltip>
                                            </div>
                                        </div>
                                        <div className="field_wrap">
                                            <div className="cc_txt"><p className="cc_para">Provide your credit card information for billing purposes. Prepaid cards will not be accepted</p></div>
                                            <div className="common_txtBox_row credit_card_field" >
                                                <label>Card Number, expiry date and CVC
                                                    <span className="svg_wrap" data-tip data-for="creditcard">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text autoFocus={ true } transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span>
                                                    <ReactTooltip id="creditcard" effect="solid" place="right" multiline={ true }>
                                                        For Visa, MasterCard, and Discover cards,<br></br> the CVV is the last 3 digit number located on the back of your card on <br></br> or above your signature line. For an American Express card,<br></br> it is the 4 digits on the FRONT above the end of your card number.
                                                    </ReactTooltip>
                                                </label>
                                                { this.state.showCardSection && <CardSection /> }

                                                <div className="customCreditCard_wrap" id="readOnlyCCDiv" style={ { display: this.state.updateCCAction ? "none" : "" } }>
                                                    <div className="customCreditCard">
                                                        <div className={ 'card_num ' + this.state.cardType }>************{ this.state.lastdigits }</div>
                                                        <div className="expiry_num"><span id="read_exp_month">{ this.state.month }</span>&nbsp;/&nbsp;<span id="read_exp_year">{ this.state.year }</span></div>
                                                    </div>
                                                </div>
                                                <p className="form_note">An amount of $1.00 will be charged and placed in temporary hold for validating your card. The amount will be refunded post verification. After that, you will be charged only for the services used.</p>
                                                <div id="card-element"></div>
                                                <div id="card-errors" role="alert"></div>
                                            </div>


                                            <div className="field_wrap field_wrap_col1 field_border_btm">
                                                <div className="fw_row1">
                                                    <div className="common_txtBox_row">
                                                        <label>Billing Address</label>
                                                        <input type="text" ref={ this.billingAddressInput } name="billingAddress" id="billingAddress" value={ this.state.billingAddress } onChange={ this.handleFormChanges } className="txtBox" maxLength="100" ></input>
                                                        <span className="err_msg" id="billingAddressErr" style={ { display: this.state.billingAddressEmpty ? 'inline-block' : 'none' } }>Billing Address cannot be blank</span>
                                                    </div>

                                                    <div className="common_txtBox_row">
                                                        <label>Zip Code</label>
                                                        <input type="text" ref={ this.zipCodeInput } name="zipCode" id="zipCode" value={ this.state.zipCode } onChange={ this.handleFormChanges } onFocus={ (e) => this.getFocus(e, "zipcode") } onClick={ (e) => this.getFocus(e, "zipcode") } className="txtBox" maxLength="20"></input>
                                                        <span className="err_msg" id="zipCodeErr" style={ { display: this.state.zipCodeEmpty ? 'inline-block' : 'none' } } >Zip Code cannot be blank</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="popup_footer popup_footer_left">
                                            <div className="popup_footer_link"><a style={ { display: this.state.updateCCAction ? "none" : "block" } } onClick={ this.showStripeForm }>Update new card</a></div>
                                            <div className="popup_footer__btns button_inverse">
                                                <button className="btn blue" id="saveChangesBtn" onClick={ event => this.saveChangesClick(event) }>Save</button>
                                                <button className="btn btn_cancel" id="cancelPopupBtn" onClick={ event => this.closePopupBtnClick(event) }>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {/** END Upgrade CC Popup */ }

                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </Fragment >
        );
    }
}

export default withRouter(TopRightHeader);